import { FormEvent, useContext, useEffect, useState } from 'react';

import { Link, useNavigate, useSearchParams } from 'react-router-dom';

import AuthApi from '../../api/authApi';
import womanWithOpenSign from '../../assets/images/woman-with-open-sign-ketut-subiyanto.jpeg';
import Button from '../../components/atoms/button';
import Input from '../../components/atoms/input';
import Page from '../../components/page-layout/Page';
import UserProfileData from '../../types/userProfileData';
import { AuthContext } from '../../utils/AuthProvider';
import ModalContext from '../../utils/ModalContext';

const INPUT_FIELDS = {
  email: {
    autoFocus: true,
    autoComplete: 'user',
    id: 'email',
    label: 'Email',
    placeholder: 'Enter email address',
    required: true,
    type: 'email',
  },
  password: {
    autoComplete: 'password',
    id: 'password',
    label: 'Password',
    type: 'password',
    placeholder: 'Enter password',
    required: true,
  },
};

enum ERROR_CODE {
  USER_NOT_FOUND = 'auth/user-not-found',
  INVALID_PASSWORD = 'auth/wrong-password',
}

export default function SignIn() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isDisabled, setIsDisabled] = useState(false);

  let navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirectTo = searchParams.get('redirectTo');

  const { user } = useContext(AuthContext)!;
  const { showAlertModal } = useContext(ModalContext);

  if (user) {
    navigate('/home');
  }

  useEffect(() => {
    document.title = 'Fordonsdalen Sign In';
  });

  function onSignIn(event: FormEvent) {
    setIsDisabled(true);
    event.preventDefault();
    AuthApi.signin(email, password)
      .then(([, userProfile]) => onSuccess(userProfile))
      .catch(error => onFailure(error));
  }

  function onSuccess(userProfile: UserProfileData | null) {
    if (userProfile) {
      navigate(redirectTo || '/');
    } else {
      navigate('/profile');
    }
  }

  function onFailure(error: any) {
    console.error('Error', error);
    if (error.message.includes(ERROR_CODE.USER_NOT_FOUND)) {
      showAlertModal(`${email} is not a registered user`);
    } else if (error.message.includes(ERROR_CODE.INVALID_PASSWORD)) {
      showAlertModal(`Invalid password. Try again`);
    } else {
      showAlertModal(`Could not login`);
    }
    setIsDisabled(false);
  }

  return (
    <Page
      className="signin dual-hero-form"
      padding={false}
      breadcrumbs={[
        ['/', 'Home'],
        ['/signin', 'Sign In'],
      ]}
    >
      <section className="column column-form">
        <form className="form" onSubmit={onSignIn}>
          <h1 className="title">Welcome back!</h1>
          <p className="subtitle">Please enter your details</p>
          <Input className="mb-4" {...INPUT_FIELDS.email} state={[email, setEmail]} />
          <Input className="mb-4" {...INPUT_FIELDS.password} state={[password, setPassword]} />
          <br />
          <Button className="button w-full" type="submit" disabled={isDisabled}>
            Sign in
          </Button>
          <br />
          <br />
          <Link className="link-button" to={'/recover-password'}>
            Forgot password?
          </Link>
          <br />
          <br />
          <p>
            Don&apos;t have an account?{' '}
            <Link
              className="link-button"
              to={{
                pathname: '/register',
                search: redirectTo ? `?redirectTo=${redirectTo}` : undefined,
              }}
            >
              Register
            </Link>
          </p>
        </form>
      </section>

      <section className="column column-hero">
        <img src={womanWithOpenSign} alt="Woman holding an open sign" />
      </section>
    </Page>
  );
}
